
import Vue from 'vue'

export default Vue.extend({
  name: 'RIcon',
  props: {
    of: {
      type: String,
    },
    height: {
      type: [String, Number],
      default: 30,
    },
    width: {
      type: [String, Number],
      default: 30,
    },
    minY: {
      type: [String, Number],
      default: 0,
    },
    minX: {
      type: [String, Number],
      default: 0,
    },
    vHeight: {
      type: [String, Number],
      default: 30,
    },
    vWidth: {
      type: [String, Number],
      default: 30,
    },
    viewBox: {
      type: String,
    },
    fill: {
      type: String,
      default: 'none',
    },
    stroke: {
      type: String,
      default: 'var(--textPrimary)',
    },
  },
  computed: {
    component(): () => any {
      // BUG: Despite it being a computed property,
      // the import is not reevaluated on props change.
      return () => import(`./${this.of}.vue`)
    },
    /**
     * Unfortunately, we've been using 4 separate props to compose a single viewbox 😭
     * This computed property exists to allow us to use `viewBox` attribute to overwrite
     * the composed one without breaking the existing icons 💪‍‍
     */
    finalViewBox(): string {
      return this.viewBox
        ? this.viewBox
        : `${this.minX} ${this.minY} ${this.vWidth} ${this.vHeight}`
    },
  },
})
